export const THEME_KEY = "theme";
export const BODY_THEME_KEY = "data-theme";
export const LIGHT_THEME = "light";
export const DARK_THEME = "dark";
export const JWT_TOKEN = "jwt_token";
export const APP_NAME = "Cutora.io";
export const APP_DOMAIN = "https://www.cutora.io";
export const LANDING_PAGE_CONTAINER_ID = "landing-container-id";

export type DarkOrLightType = "dark" | "light";